
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "../store/rootSaga";
import rootReducer from "../store/rootReducer";
import defaultState from './defaultStore';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, defaultState, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);
export default store;